import React from 'react';
import * as styles from './base.scss';
import { pushState } from 'Shared/history';
import { updateODPTrackingSearchResultProductClick, getGa4ItemListReferrel, getGa4ItemListReferrelContext, setGa4ItemListReferrelContextFromEvent, addEcommerceEventToDataLayer } from './../../../TrackingInformation';
import connect from 'Shared/connect';
import { selectVariant } from 'Shared/Product/action-creators';
import ProductPreview from '../ProductPreview';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
const ProductLink = ({ linkUrl, ticket, children, title, searchTerm, code, selectItemEventList, products, pageType, selectVariant, product, openPreviewInModal, selectProudctVariant, selectItemEvent, cartSelectItemEventList, cart, minicartIsOpen, }) => {
    if (!linkUrl) {
        return React.createElement(React.Fragment, null, children);
    }
    const getSelectedVariants = (code) => {
        const articleNumber = code.split('_')[0];
        const cartProducts = !!cart &&
            !!cart.items &&
            cart.items.map(function (i) {
                return i.product;
            });
        let allProducts = [];
        if (!!cartProducts && !!products) {
            allProducts = products.concat(cartProducts);
        }
        else if (!!cartProducts) {
            allProducts = cartProducts;
        }
        else if (!!products) {
            allProducts = products;
        }
        let product = !!allProducts && allProducts.find(x => epiPropertyValue(x.content.code) === articleNumber);
        return !!product && product.variants;
    };
    const sendGa4Event = (code) => {
        var _a, _b;
        var ga4selectEvent;
        const productTrackingData = (_a = product) === null || _a === void 0 ? void 0 : _a.trackingData;
        if (!!selectItemEvent) {
            ga4selectEvent = selectItemEvent;
        }
        else if (!!cartSelectItemEventList && code in cartSelectItemEventList && minicartIsOpen) {
            ga4selectEvent = cartSelectItemEventList[code];
        }
        else if (!!((_b = productTrackingData === null || productTrackingData === void 0 ? void 0 : productTrackingData.ga4EventObjects) === null || _b === void 0 ? void 0 : _b['select_item'])) {
            const productSelectItemEventList = productTrackingData.ga4EventObjects['select_item'];
            ga4selectEvent = !!productSelectItemEventList && code in productSelectItemEventList && productSelectItemEventList[code];
        }
        else {
            ga4selectEvent = !!selectItemEventList && code in selectItemEventList && selectItemEventList[code];
        }
        if (ga4selectEvent) {
            setGa4ItemListReferrelContextFromEvent(ga4selectEvent);
            addEcommerceEventToDataLayer(ga4selectEvent);
        }
    };
    const linkTo = (e, url, code) => {
        if (e.ctrlKey) {
            return true;
        }
        e.preventDefault();
        !!searchTerm && updateODPTrackingSearchResultProductClick(searchTerm, window.location.href);
        sendGa4Event(code);
        const variants = getSelectedVariants(code);
        !!code && !!variants && selectVariant(code, variants);
        let updatedUrl = url;
        const ga4ItemListReferrel = getGa4ItemListReferrelContext() || getGa4ItemListReferrel();
        if (ga4ItemListReferrel != null) {
            const separator = url.includes('?') ? '&' : '?';
            updatedUrl += `${separator}ga4ItemListReferrel=${encodeURIComponent(ga4ItemListReferrel)}`;
        }
        pushState(updatedUrl);
        document.dispatchEvent(new CustomEvent('PeeriusTrackingClick', { detail: code }));
    };
    return !!openPreviewInModal && !!product && !!selectProudctVariant ? (React.createElement(ProductPreview, { product: product, selectedVariant: selectProudctVariant, selectItemEvent: selectItemEvent }, children)) : (React.createElement("a", { href: linkUrl, onClick: e => linkTo(e, linkUrl, code), "data-may-prevent-default": true, "data-ticket": ticket, className: styles.link, title: title }, children));
};
export default connect((state) => ({
    selectItemEventList: state.currentPage &&
        state.currentPage.trackingData &&
        state.currentPage.trackingData.ga4EventObjects &&
        state.currentPage.trackingData.ga4EventObjects['select_item'],
    cartSelectItemEventList: state.cart &&
        state.cart.trackingData &&
        state.cart.trackingData.ga4EventObjects &&
        state.cart.trackingData.ga4EventObjects['select_item'],
    cart: state.cart,
    minicartIsOpen: !!state.miniCart && state.miniCart.isOpen,
    products: !!state.currentPage && !!state.currentPage.products && state.currentPage.products.products,
    pageType: !!state.currentPage && state.currentPage.componentName,
}), (dispatch) => ({
    selectVariant: (code, variants) => dispatch(selectVariant(code, variants)),
}))(ProductLink);
